let loadPromise: Promise<void> | null = null;

export const getMetaConfig = () => {
    const appId = import.meta.env.VITE_META_APP_ID as string | undefined;
    return { appId };
};

export const loadFacebookSdk = async () => {
    const { appId } = getMetaConfig();
    if (!appId) {
        throw new Error('Missing VITE_META_APP_ID');
    }

    if (loadPromise !== null) {
        return loadPromise;
    }

    loadPromise = new Promise<void>((resolve, reject) => {
        const g = globalThis as unknown as { FB?: { init: (p: { appId: string; version: string }) => void } };

        // already loaded
        if (g.FB) {
            resolve();
            return;
        }

        (globalThis as unknown as Window).fbAsyncInit = function () {
            try {
                g.FB?.init({
                    appId,
                    version: 'v25.0',
                });
                resolve();
            } catch (e) {
                reject(e);
            }
        };

        const existing = document.querySelector('script[data-meta-sdk="facebook"]');
        if (existing) {
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.async = true;
        script.defer = true;
        script.dataset.metaSdk = 'facebook';
        script.onerror = () => reject(new Error('Failed to load Facebook SDK'));
        document.body.appendChild(script);
    });

    return loadPromise;
};

